import Repository from './Repository'

export default {
  createQuestionResponse (params) {
    return Repository.private().post(
      '/dashboard/questions/', params
    )
  },
  getQuestionsResponses () {
    return Repository.private().get(
      '/dashboard/questions'
    )
  },
  updateQuestionsResponses (id, params) {
    return Repository.private().put(
      '/dashboard/questions/' + id + '/', params
    )
  },
  deleteQuestionResponse (id) {
    return Repository.private().delete(
      '/dashboard/questions/' + id
    )
  }
}
